import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarRemove4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-remove-4"} maskId="square-filled-radius-0-stroke-1-IconCalendarRemove4"><path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H16V4H8V2H7V4ZM9.24805 9.04289L8.54094 9.75L11.2928 12.5018L8.54289 15.2517L9.25 15.9588L11.9999 13.2089L14.7497 15.9588L15.4568 15.2517L12.707 12.5018L15.4588 9.75L14.7517 9.04289L11.9999 11.7947L9.24805 9.04289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarRemove4;
